import React from "react";
import InputBase from "./InputBase";
import Convert from "../../common/Convert";
import {
    Label
} from "reactstrap";
import Datetime from "react-datetime";
import ReactDOM from 'react-dom'

const moment = require("moment");

export default class InputDatetime extends InputBase {
    static defaultProps = {
        label:'日付',
        labelOn:false,
        name:'',
        className:'',
        style:{},
        maxlength : 1024,
        multiline: false,
        enterSearchFlag: false,
        timeFormat: false,
        rootData:{
            values:{},
            errors:{},
            requiredData:{}
        }
    }
    constructor(props) {
        super(props);

        // console.log("props.valid_threemonth",props.valid_threemonth);

        this.state = {
            value: '',
            format_value: '',

            // 
            valid_threemonth: props.valid_threemonth!=undefined? props.valid_threemonth: true,
        };
        this.inputRef = React.createRef();
        this.handle_change = this.handle_change.bind(this);
        this.handle_blur = this.handle_blur.bind(this);
        this.getValidDates = this.getValidDates.bind(this);
    }
    componentDidMount(){
        const name = Convert.key_split(this.props.name).column
        if (this.selfDom.current) {
            ReactDOM.findDOMNode(this.selfDom.current).value=this.props.rootData.values[name]
        }
        var buf = this.props.rootData.values[name] == null ? "" : this.props.rootData.values[name];
        this.setState({
            value: moment(new Date(buf)),
            format_value: buf
        })
    }


    componentDidUpdate(prevProps){
        const name = Convert.key_split(this.props.name).column
        if(this.props.rootData.values && prevProps.rootData.values && (prevProps.rootData.values[name])!=(this.props.rootData.values[name])){
            if (this.selfDom.current) {
                ReactDOM.findDOMNode(this.selfDom.current).value=this.props.rootData.values[name]
            }
            var buf = this.props.rootData.values[name] == null ? "" : this.props.rootData.values[name];
            this.setState({
                value: moment(new Date(buf)),
                format_value: buf
            })
        }
    }

    handle_change(e) {
        if (e.format){
            const {
                validateType,
                name,
                timeFormat
            } = this.props
            const formattedValue = timeFormat ? e.format("YYYY-MM-DDTHH:mm:00") 
            : (validateType=="search" && name.includes('_to'))
                ? e.format("YYYY-MM-DDT23:59:59")
                : e.format("YYYY-MM-DDT00:00:00")
            const format_value = formattedValue!=="Invalid date"?formattedValue:""
            this.setState({ value: e, format_value }, () => { this.validate(format_value); });
        } else if ( this.props.validateType=="regist"
            &&e.toString().includes("/")
            &&e.toString().split("/")[1]
        ){
            const year = moment().format('YYYY')
            const value = moment(new Date(`${year}/${e.toString()}`))
            
            // 3ヵ月以上前の日付（当日と比較）の場合、年度を+1する
            const before3month = moment().subtract(3, 'months');
            if(value < before3month){
                value.add(1, 'year')
            }

            const formattedValue = value.format("YYYY-MM-DDT00:00:00")
            const format_value = formattedValue!=="Invalid date"?formattedValue:""
            this.setState({ value: value, format_value }, () => { this.validate(format_value); });
        } else if ( this.props.validateType=="search"
            && (e.toString().length===10&&e.toString().includes("/")&&e.toString().split("/")[2])
        ){
            const value = moment(new Date(`${e.toString()}`))
            const formattedValue = value.format("YYYY-MM-DDT00:00:00")
            const format_value = formattedValue!=="Invalid date"?formattedValue:""
            this.setState({ value: value, format_value }, () => { this.validate(format_value); });
        } else if ( this.props.validateType=="search"
            && e.toString().includes("年")&&e.toString().includes("月")&&e.toString().includes("日")
        ){
            if (e.toString().includes("（") && !e.toString().includes("）")) {
                this.validate("", ()=>{
                    if (this.selfDom.current) {
                        ReactDOM.findDOMNode(this.selfDom.current).value=""
                    }
                })
                return
            }
            const dateString = e.toString().replace("年","/").replace("月","/")
            const value = moment(new Date(dateString.substr(0,dateString.indexOf("日"))))
            const formattedValue = value.format("YYYY-MM-DDT00:00:00")
            const format_value = formattedValue!=="Invalid date"?formattedValue:""
            this.setState({ value: value, format_value }, () => { this.validate(format_value); });
        }
    }

    handle_blur(e) {
        if (e.length!=0&&e.format){
            const {
                validateType,
                name,
                timeFormat
            } = this.props
            const formattedValue = timeFormat ? e.format("YYYY-MM-DDTHH:mm:00") 
            : (validateType=="search" && name.includes('_to'))
                ? e.format("YYYY-MM-DDT23:59:59")
                : e.format("YYYY-MM-DDT00:00:00")
            const format_value = formattedValue!=="Invalid date"?formattedValue:""
            this.setState({ value: e, format_value }, () => { this.validate(format_value); });
        } else {
            if (this.selfDom.current) {
                this.setState({value:" "}, ()=>this.setState({value:""}))
            }
        }
    }
    getValidDates (currentDate){
        // console.log("getValidDates",this.state.valid_threemonth);
        var day = moment().subtract(3, 'months');
        // return this.state.valid_threemonth? currentDate.isAfter(day): true;
        return true;
    }
    render() {
        const{
            labelOn,
            name,
            label,
            // className,
            rootData:{
                errors,
                values,
                // requiredData
            },
            disabled=false,
            validateType
        } = this.props
        
        const columnObject = Convert.key_split(name)
        const defaultValue = values&&values[columnObject.column]&&moment(new Date(values[columnObject.column])) || ""
        const validate_message = errors&&errors[columnObject.column]
        return (
            <>
                {
                    labelOn &&
                    <Label for={name} className="search-text-order">
                        {label}
                        ：
                    </Label>
                }
                <div style={{padding:0, margin:0, position:"relative"}}>
                    <Datetime 
                            timeFormat={this.props.timeFormat} 
                            dateFormat={this.props.validateType=="regist"?"MM/DD":"YYYY年MM月DD日（ddd）"}
                            isValidDate={ validateType !== "search" ? this.getValidDates : ()=>true}
                            input={true} 
                            onChange={this.handle_change}
                            onBlur={this.handle_blur}
                            defaultValue={defaultValue}
                            open={disabled?false:undefined}
                            closeOnSelect={true}
                            inputProps={
                                {
                                    placeholder:label +"を入力してください",
                                    readOnly:disabled,
                                    id:name,
                                    ref:this.selfDom,
                                    autoComplete:"off"
                                }
                            }
                            value={this.state.value?this.state.value:defaultValue}
                            className={`tabable`} 
                            renderInput={(props) => {
                                return <input {...props} value={(this.state.format_value) ? props.value : ''} />
                            }}
                    />
                    {defaultValue!=undefined&&!disabled&&defaultValue!==""&&<svg 
                            style={{
                                position: "absolute",
                                right: "8px",
                                top: 0,
                                height: "calc(2.25rem + 2px)",
                            }}
                            height="20" 
                            width="20" 
                            viewBox="0 0 20 20" 
                            aria-hidden="true" 
                            focusable="false" 
                            className="css-6q0nyr-Svg text-clear-btn"
                            onClick={()=>{this.validate("")}}
                        >
                        <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
                    </svg>}
                </div>
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}